import { Component, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { FormlyFieldConfig } from "@ngx-formly/core";
import * as crypto from "crypto-js";
import { Globals } from "../../app.globals";
import { ClientSwitcherComponent } from "../../components/client-switcher/client-switcher.component";
import { NavService } from "../../services/nav.service";
import { UserService } from "../../services/user.service";

@Component({
        standalone: false,
    templateUrl: "./login.component.html",
})
export class LoginPage {
    form: FormGroup;
    login: any = {};
    loginFields: Array<FormlyFieldConfig> = [];
    forceDisable: boolean = false;

    @ViewChild("clientSwitcher") clientSwitcher: ClientSwitcherComponent;

    constructor(
        private userService: UserService,
        private navService: NavService,
        formBuilder: FormBuilder,
        private router: Router,
        private globals: Globals
    ) {
        this.form = formBuilder.group({});

        this.loginFields = [
            {
                fieldGroup: [
                    {
                        key: "email",
                        type: "hz-input",
                        props: {
                            type: "email",
                            label: "Email",
                            placeholder: "username@email.com",
                            required: true,
                        },
                    },
                    {
                        key: "password",
                        type: "hz-input",
                        props: {
                            type: "password",
                            label: "Password",
                            placeholder: "********",
                            required: true,
                        },
                    },
                ],
            },
        ];

        this.login = {};
    }

    ngOnInit() {
        this.navService.setClient(null);
    }

    submit() {
        this.forceDisable = true;
        this.globals.showSpinner();
        this.userService
            .loginUser(
                this.login.email,
                crypto.SHA512(this.login.password).toString()
            )
            .subscribe(
                (data) => {
                    this.globals.hideSpinner();
                    if (data.numberOfAssignedClients == 1) {
                        this.userService.setUser(data);
                        this.redirectFromLogin();
                    } else {
                        this.forceDisable = false;
                        this.clientSwitcher.show();
                    }
                },
                (err) => {
                    this.forceDisable = false;
                    alert(err);
                    this.globals.hideSpinner();
                }
            );
    }

    redirectFromLogin() {
        this.router.navigateByUrl("home");
    }
}
